import { noop } from 'lodash';
import { useEffect, useCallback, useRef } from 'react';

const useTimeout = (
  callback = noop,
  timeout = 0,
  {
    // manage re-render behavior.
    // by default, a re-render in your component will re-define the callback,
    //    which will cause this timeout to cancel itself.
    // to avoid cancelling on re-renders (but still cancel on unmounts),
    //    set `persistRenders: true,`.
    persistRenders = false,
  } = {}
) => {
  const timeoutIdRef = useRef();
  const cancel = useCallback(
    () => {
      const timeoutId = timeoutIdRef.current;
      if (timeoutId) {
        timeoutIdRef.current = void 0;
        clearTimeout(timeoutId);
      }
    },
    [timeoutIdRef],
  );

  useEffect(
    () => {
      timeoutIdRef.current = setTimeout(callback, timeout);
      return cancel;
    },
    persistRenders
      ? []
      : [callback, timeout, cancel],
  );

  return cancel;
};

export default useTimeout;
